import axios from 'axios'
const baseURL = process.env.VUE_APP_BITS_API_BASE || 'http://chaindataapi.bitnetworkbc.com/bitscan'
//const baseURL2 =  'http://192.168.56.109:9016'
const instance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  timeout: 16000,
  withCredentials: false
})

// 修改instance方法以支持完整URL
const originalRequest = instance.request;
instance.request = function(config) {
  // 如果URL是完整的HTTP/HTTPS链接，清除baseURL
  if (config.url && (config.url.startsWith('http://') || config.url.startsWith('https://'))) {
    config.baseURL = '';
  }
  return originalRequest.call(this, config);
};

// 请求拦截器 添加token， 判断登录之类操作
instance.interceptors.request.use(
  config => {
    // 在这里做认证，可以从store里面获取token
    config.headers['lang'] = localStorage.getItem('lang')
    config.headers['token'] = localStorage.getItem('token')
    config.headers['address'] = localStorage.getItem('address')
    config.headers['time'] = localStorage.getItem('time')
    // 如果get  请求有缓存，可以加这段代码
    // if (config.method === 'get') {
    //   const now = `${Date.now()}`
    //   if (config.params) {
    //     config.params[now] = now
    //   } else {
    //     const hasParams = config.url.includes('?')
    //     config.url = config.url + (hasParams ? '&' : '?') + `${now}=${now}`
    //   }
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器，对返回数据进行预处理
instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error)
  }
)
/**
 * 对 请求进行封装 只有 status 与 code 都是200 才会进入 then , 否则均进入 catch
 * @param {*} options
 */
const request = (options = {}) => {
  return new Promise((resolve, reject) => {
    instance(options)
      .then(({ data, status, statusText }) => {
        if (status >= 200 && status < 300) {
          if (data && data.status == 401) {
            sessionStorage.clear()
            window.location.reload()
            reject('您还未登录')
          } else {
            resolve(data)
          }
        } else {
          reject((data && data.message) ? data.message : statusText)
        }
      })
      .catch(result => {
        if (!result || !result.response) {
          reject(result)
        }
        const {
          response: { status, statusText, data = {} }
        } = result
        switch (status) {
          // 未登录
          case 401:
            sessionStorage.clear()
            reject('您还未登录')
            break
          case 403:
            reject('登录失效')
            break
          case 404:
            reject('访问异常，请联系系统管理员')
            // 请求丢失
            break
          default:
            reject(data.message || statusText)
            break
        }
      })
  })
}

const get = (url, params = {}) => {
  return request({
    url,
    method: 'get',
    params
  })
}

const put = (url, params = {}) => {
  return request({
    url,
    method: 'put',
    params
  })
}

const post = (url, data = {}) => {
  return request({
    url,
    method: 'post',
    data
  })
}

const del = (url, params = {}) => {
  return request({
    url,
    method: 'delete',
    params
  })
}
// 将获取cancelToken的方法绑定到每个方法上面，方便调用的时候使用
;[request, get, post, put, del, instance].forEach(item => {
  item.getCancelToken = () => {
    return axios.CancelToken
  }
})

/**
 * request 对请求进行二次包装，处理了异常编码
 * get
 * set
 * axios 对axios进行包装之后的原生实例
 */
export { request, get, post, put, del, instance as axios, baseURL }
